import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { SeguridadSocial } from '../models/seguridad-social';

const baseUrl = environment.hostService + '/SeguridadSocial';

@Injectable({
  providedIn: 'root'
})
export class SeguridadSocialService {
    
  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getByPersonalId(personalId: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPersonalId/' + personalId })
  }

  getHistoryByPersonalId(personalId: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetHistoryByPersonalId/' + personalId })
  }

  save(datos: SeguridadSocial, cortarRegistro: boolean): Observable<any>
  {
    return this._http.post<any>({ url: baseUrl + '/Save/' + cortarRegistro, body: datos });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });
  }
}

